import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Input, Label, FormGroup } from 'reactstrap';
const WeekEndingFilterOption = _ref => {
  let option = _ref.option,
    onSelect = _ref.onSelect,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected;
  const id = option.id,
    name = option.name;
  const handleItem = () => onSelect(option);
  return /*#__PURE__*/React.createElement("div", {
    key: "div-".concat(id)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormGroup, {
    check: true
  }, /*#__PURE__*/React.createElement(Label, {
    check: true
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    className: "t-ts-option t-ts-option-".concat(kebabCase(name)),
    key: "chk-".concat(id),
    onChange: handleItem,
    checked: selected
  }), ' ', name))), /*#__PURE__*/React.createElement("hr", null));
};
WeekEndingFilterOption.propTypes = {
  onSelect: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  selected: PropTypes.bool
};
export default WeekEndingFilterOption;